// queries/useErrorLogs.ts
"use client";
import { fetch } from "libs";
import { GET_ERROR_LOGS } from "api";
import { useQuery } from "@tanstack/react-query";

interface ErrorLogsParams {
  page: number;
  page_size: number;
  user_email?: string;
  error_category?: string;
  severity?: string;
  start_date: string;
  end_date: string;
}

export const fetchGenerationErrors = async (params: ErrorLogsParams) => {
  const searchParams = new URLSearchParams();
  Object.entries(params).forEach(([key, value]) => {
    if (value !== undefined) {
      searchParams.append(key, value.toString());
    }
  });
  
  return await fetch(`${GET_ERROR_LOGS}?${searchParams.toString()}`, {
    method: "GET",
  });
};

const useGetGenerationErrors = (params: ErrorLogsParams) =>
  useQuery({
    queryKey: ["errorLogs", params],
    queryFn: () => fetchGenerationErrors(params),
    refetchInterval: 30000, 
  });

export default useGetGenerationErrors;